import React from "react";
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ConvexReactClient } from "convex/react";
import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { authClient } from "@/lib/auth-client";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { captureError, initErrorMonitoring } from "@/lib/error-monitoring";
import ConnectionStatus from "@/components/ConnectionStatus";

const convexUrl = import.meta.env.VITE_CONVEX_URL as string;
if (!convexUrl || !convexUrl.startsWith("https://")) {
  throw new Error(
    "VITE_CONVEX_URL must be set to a valid https:// Convex deployment URL"
  );
}
const convex = new ConvexReactClient(convexUrl);

initErrorMonitoring();

window.addEventListener("error", (event) => {
  captureError(event.error ?? event.message, {
    source: "window.error",
  });
});

window.addEventListener("unhandledrejection", (event) => {
  captureError(event.reason, {
    source: "window.unhandledrejection",
  });
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="dark" storageKey="drillpoint-theme">
      <ConvexBetterAuthProvider client={convex} authClient={authClient}>
        <ConnectionStatus />
        <App />
      </ConvexBetterAuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
